const CuisinesNearMe = [
    {
      text: "Lucknowi Restaurant Near Me",
      id: "query_lucknowi",
      link: "https://www.swiggy.com/lucknowi-restaurants-near-me",
    },
    {
      text: "Asian Restaurant Near Me",
      id: "query_asian",
      link: "https://www.swiggy.com/asian-restaurants-near-me",
    },
    {
      text: "Barbecue Restaurant Near Me",
      id: "query_barbecue",
      link: "https://www.swiggy.com/barbecue-restaurants-near-me",
    },
    {
      text: "Bihari Restaurant Near Me",
      id: "query_bihari",
      link: "https://www.swiggy.com/bihari-restaurants-near-me",
    },
    {
      text: "Biryani Restaurant Near Me",
      id: "query_biryani",
      link: "https://www.swiggy.com/biryani-restaurants-near-me",
    },
    {
      text: "Burgers Restaurant Near Me",
      id: "query_burgers",
      link: "https://www.swiggy.com/burgers-restaurants-near-me",
    },
    {
      text: "Chaat Restaurant Near Me",
      id: "query_chaat",
      link: "https://www.swiggy.com/chaat-restaurants-near-me",
    },
    {
      text: "Grill Restaurant Near Me",
      id: "query_grill",
      link: "https://www.swiggy.com/grill-restaurants-near-me",
    },
    {
      text: "Hyderabadi Restaurant Near Me",
      id: "query_hyderabadi",
      link: "https://www.swiggy.com/hyderabadi-restaurants-near-me",
    },
    {
      text: "Ice Cream Restaurant Near Me",
      id: "query_ice_cream",
      link: "https://www.swiggy.com/ice-cream-restaurants-near-me",
    },
    {
      text: "Indian Restaurant Near Me",
      id: "query_indian",
      link: "https://www.swiggy.com/indian-restaurants-near-me",
    },
    {
      text: "Juices Restaurant Near Me",
      id: "query_juices",
      link: "https://www.swiggy.com/juices-restaurants-near-me",
    },
    {
      text: "Kebabs Restaurant Near Me",
      id: "query_kebabs",
      link: "https://www.swiggy.com/kebabs-restaurants-near-me",
    },
    {
      text: "North Indian Restaurant Near Me",
      id: "query_north_indian",
      link: "https://www.swiggy.com/north-indian-restaurants-near-me",
    },
    {
      text: "Pan-Asian Restaurant Near Me",
      id: "query_pan-asian",
      link: "https://www.swiggy.com/pan-asian-restaurants-near-me",
    },
    {
      text: "Pizzas Restaurant Near Me",
      id: "query_pizzas",
      link: "https://www.swiggy.com/pizzas-restaurants-near-me",
    },
    {
      text: "Seafood Restaurant Near Me",
      id: "query_seafood",
      link: "https://www.swiggy.com/seafood-restaurants-near-me",
    },
    {
      text: "Street Food Restaurant Near Me",
      id: "query_street_food",
      link: "https://www.swiggy.com/street-food-restaurants-near-me",
    },
    {
      text: "Sweets Restaurant Near Me",
      id: "query_sweets",
      link: "https://www.swiggy.com/sweets-restaurants-near-me",
    },
    {
      text: "Tandoor Restaurant Near Me",
      id: "query_tandoor",
      link: "https://www.swiggy.com/tandoor-restaurants-near-me",
    },
  ];
  
  export default CuisinesNearMe;